import {
  ADMIN_ROLE,
  INSTRUCTOR_ROLE,
  SETTING_SUB_ROUTE,
  SIDEBAR_MODE,
  STUDENT_ROLE,
} from "@constants";
import { MainLayout, SecondLayout } from "@layouts";
import { AuthLayout } from "@layouts/AuthLayout/AuthLayout";
import {
  AccountSetting,
  CourseCheckout,
  CreateCourseSuccessPage,
  EditingCoursePage,
  EarningPage,
  ExplorePage,
  HomePage,
  InstructorCoursesPage,
  InstructorDashboardPage,
  PayoutPage,
  ProfileSetting,
  SavedCoursesPage,
  SettingPage,
  SignIn,
  SignUp,
  SignUpStep,
  // UpdateCoursePage,
  MyPurchasedCourse,
  MyLearningPage,
  ShoppingCart,
  ReviewsPage,
  AllInstructorPage,
  InstructorReviewPage,
  ManageCourses,
  CodeValidate,
  CourseDetailViewPage,
  Credits,
  Statements,
  LearningPage,
  MyProfilePage,
  InvoicePage,
} from "@pages";
import { ManageInstructors } from "@pages/ManageUser/ManageInstructors";
import { ManageStudents } from "@pages/ManageUser/ManageStudents";
import React, { Fragment } from "react";
import { Navigate, Route } from "react-router-dom";
import { PrivateRoute } from "./privateRoute";

const guards = (
  <Fragment>
    <Route element={<PrivateRoute targetRoles={[STUDENT_ROLE]} />}>
      {/* <Route element={<MainLayout />}>
        <Route path="/my-profile-view" element={<MyStudentProfilePage />} />
      </Route> */}
      <Route element={<MainLayout sidebarMode={SIDEBAR_MODE.DASHBOARD} />}>
        <Route
          path="/student-dashboard"
          element={<Navigate to={"/my-learning"} replace />}
        />
        {/* <Route path="/student-credits" element={<></>} /> */}
        <Route path="/student-courses" element={<></>} />
        {/* <Route path="/messages" element={<></>} />
        <Route path="/notification" element={<></>} />
        <Route path="/my-certificates" element={<></>} /> */}
        <Route path="/my-reviews" element={<ReviewsPage />} />
        {/* <Route path="/statements" element={<></>} /> */}
      </Route>
    </Route>
    <Route element={<PrivateRoute targetRoles={[INSTRUCTOR_ROLE]} />}>
      {/* <Route element={<MainLayout />}>
        <Route path="/my-profile-view" element={<MyInstructorProfilePage />} />
      </Route> */}
      <Route element={<MainLayout sidebarMode={SIDEBAR_MODE.DASHBOARD} />}>
        <Route
          path="/instructor-dashboard"
          element={<InstructorDashboardPage />}
        />
        <Route path="/instructor-analytics" element={<></>} />
        <Route path="/create-new-course" element={<EditingCoursePage />} />
        <Route path="/update-course/:id" element={<EditingCoursePage />} />,
        <Route
          path="/update-course/"
          element={<Navigate to={"/instructor-courses"} replace />}
        />
        <Route
          path="/create-course-success"
          element={<CreateCourseSuccessPage />}
        />
        <Route path="/instructor-courses" element={<InstructorCoursesPage />} />
        <Route path="/instructor-earning" element={<EarningPage />} />
        <Route path="/instructor-payout" element={<PayoutPage />} />
        <Route
          path="/instructor-all-reviews"
          element={<InstructorReviewPage />}
        />
        <Route path="/my-reviews-ins" element={<ReviewsPage />} />
        <Route path="/statements" element={<Statements />} />
      </Route>
    </Route>
    <Route element={<PrivateRoute targetRoles={[ADMIN_ROLE]} />}>
      <Route element={<MainLayout sidebarMode={SIDEBAR_MODE.ADMIN} />}>
        <Route
          path="/admin"
          element={<Navigate to={"/admin-manage-courses"} replace />}
        />
        <Route path="/admin-manage-courses" element={<ManageCourses />} />
        <Route
          path="/admin-course-detail-view/:id"
          element={<CourseDetailViewPage />}
        />
        <Route path="/admin-manage-categories" element={<>categories</>} />
        <Route path="/admin-manage-students" element={<ManageStudents />} />
        <Route
          path="/admin-manage-instructors"
          element={<ManageInstructors />}
        />
        <Route path="/admin-manage-admins" element={<>adm</>} />
        <Route path="/admin-setting" element={<SettingPage />}>
          <Route
            index
            element={<Navigate to={SETTING_SUB_ROUTE.PROFILE} replace />}
          />
          <Route
            path={SETTING_SUB_ROUTE.PROFILE}
            element={<ProfileSetting />}
          />
          <Route
            path={SETTING_SUB_ROUTE.ACCOUNT}
            element={<AccountSetting />}
          />
        </Route>
      </Route>
    </Route>
    <Route
      element={<PrivateRoute targetRoles={[STUDENT_ROLE, INSTRUCTOR_ROLE]} />}
    >
      <Route path="/learning/:id/" element={<LearningPage />} />
      <Route
        path="/learning/:id/lesson/:lessonId"
        element={<LearningPage />}
      />
      <Route path="/invoice/:id/" element={<InvoicePage />} />
      <Route element={<MainLayout />}>
        <Route path="/my-profile-view" element={<MyProfilePage />} />
        <Route path="/saved-courses" element={<SavedCoursesPage />} />
        <Route path="/setting" element={<SettingPage />}>
          <Route
            index
            element={<Navigate to={SETTING_SUB_ROUTE.PROFILE} replace />}
          />
          <Route
            path={SETTING_SUB_ROUTE.PROFILE}
            element={<ProfileSetting />}
          />
          <Route
            path={SETTING_SUB_ROUTE.ACCOUNT}
            element={<AccountSetting />}
          />
        </Route>
        <Route path="/saved-courses" element={<SavedCoursesPage />} />
      </Route>

      <Route element={<MainLayout sidebarMode={SIDEBAR_MODE.DASHBOARD} />}>
        <Route path="/my-purchased-courses" element={<MyPurchasedCourse />} />,
        <Route path="/my-learning" element={<MyLearningPage />} />
        <Route path="/credits" element={<Credits />} />
      </Route>
      <Route element={<SecondLayout />}>
        <Route path="/shopping-cart" element={<ShoppingCart />} />
        <Route path="/checkout-course" element={<CourseCheckout />} />
      </Route>
    </Route>
    <Route
      element={<PrivateRoute authRequired={false} exceptRoles={[ADMIN_ROLE]} />}
    >
      <Route element={<MainLayout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/explore" element={<ExplorePage />} />
        <Route path="/all-instructors" element={<AllInstructorPage />} />
      </Route>
    </Route>
    <Route element={<PrivateRoute authRequired={false} authRejected={true} />}>
      <Route element={<AuthLayout />}>
        <Route path="/sign-in" element={<SignIn />} />
        <Route path="/sign-up" element={<SignUp />} />
        <Route path="/sign-up-step" element={<SignUpStep />} />
        <Route path="/code-validate" element={<CodeValidate />} />
      </Route>
    </Route>
  </Fragment>
);

export { guards };
